(function () {
  var APP_PROXY_BASE = '/apps/ladybae-vendor-test';
  var PATHS = {
    authorized: APP_PROXY_BASE + '/authorized-vendors-dry-run',
    lookup: APP_PROXY_BASE + '/scan/lookup',
    redeem: APP_PROXY_BASE + '/scan/redeem',
  };
  var ADMIN_CODE = 'Admin0920';
  var OFFICIAL_SCAN_SLUG = 'LadyBaeStaff';
  var OFFICIAL_SCAN_SLUGS = [ADMIN_CODE, OFFICIAL_SCAN_SLUG];
  var EARLY_REDEEM_MS = 60 * 60 * 1000;

  var config = { loggedIn: false, loginUrl: '/account/login' };
  var activeVendors = [];
  var vendorRoleBySlug = {};
  var selectedVendor = '';
  var lastCode = '';
  var lastTicket = null;
  var lastCanRedeem = false;
  var lastApiReason = '';
  var lastReasonCode = '';
  var busy = false;
  var scanning = false;
  var cameraRunning = false;
  var acceptScan = true;
  var modalOpen = false;
  var html5qr = null;

  try {
    var configEl = document.getElementById('lb-scan-v2-config');
    if (configEl) config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    config = { loggedIn: false, loginUrl: '/account/login' };
  }

  var root = document.getElementById('lb-scan-v2-root');
  if (!root) return;

  function $(id) { return document.getElementById(id); }

  var els = {
    login: $('lb-scan-v2-login'),
    noAuth: $('lb-scan-v2-no-auth'),
    bootstrap: $('lb-scan-v2-bootstrap'),
    app: $('lb-scan-v2-app'),
    fixed: $('lb-scan-v2-fixed'),
    vendor: $('lb-scan-v2-vendor'),
    vendorBtn: $('lb-scan-v2-vendor-btn'),
    vendorValue: $('lb-scan-v2-vendor-value'),
    vendorRole: $('lb-scan-v2-vendor-role'),
    vendorMenu: $('lb-scan-v2-vendor-menu'),
    vendorList: $('lb-scan-v2-vendor-list'),
    vendorSearchWrap: $('lb-scan-v2-vendor-search-wrap'),
    vendorFilter: $('lb-scan-v2-vendor-filter'),
    staff: $('lb-scan-v2-staff'),
    code: $('lb-scan-v2-code'),
    hint: $('lb-scan-v2-hint'),
    warn: $('lb-scan-v2-warn'),
    state: $('lb-scan-v2-state'),
    camPlaceholder: $('lb-scan-v2-cam-placeholder'),
    reader: $('lb-scan-v2-reader'),
    modal: $('lb-scan-v2-modal'),
    mTitle: $('lb-scan-v2-m-title'),
    mSub: $('lb-scan-v2-m-sub'),
    mStatus: $('lb-scan-v2-m-status'),
    mName: $('lb-scan-v2-m-name'),
    mPhone: $('lb-scan-v2-m-phone'),
    mId4: $('lb-scan-v2-m-id4'),
    mEvent: $('lb-scan-v2-m-event'),
    mWarn: $('lb-scan-v2-m-warn'),
    mRedeem: $('lb-scan-v2-m-redeem'),
    mDone: $('lb-scan-v2-m-done'),
    mClose: $('lb-scan-v2-m-close'),
    mBackdrop: $('lb-scan-v2-m-backdrop'),
    fStatus: $('lb-scan-v2-f-status'),
    fPerm: $('lb-scan-v2-f-perm'),
    fName: $('lb-scan-v2-f-name'),
    fPhone: $('lb-scan-v2-f-phone'),
    fId4: $('lb-scan-v2-f-id4'),
    fEvent: $('lb-scan-v2-f-event'),
    fTime: $('lb-scan-v2-f-time'),
    fType: $('lb-scan-v2-f-type'),
    fVendor: $('lb-scan-v2-f-vendor'),
    optAutoRedeem: $('lb-scan-v2-opt-auto-redeem'),
    btnStart: [$('lb-scan-v2-btn-start'), $('lb-scan-v2-btn-start2')],
    btnStop: [$('lb-scan-v2-btn-stop'), $('lb-scan-v2-btn-stop2')],
    btnRedeem: [$('lb-scan-v2-btn-redeem'), $('lb-scan-v2-btn-redeem2')],
    btnNext: [$('lb-scan-v2-btn-next'), $('lb-scan-v2-btn-next2')],
    btnLookup: $('lb-scan-v2-btn-lookup'),
  };

  function escapeHtml(value) {
    if (value == null || value === '') return '—';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isMobileNow() {
    return window.matchMedia('(max-width: 980px)').matches;
  }

  function normCode(raw) {
    return String(raw || '').trim();
  }

  function fmtLocal(iso) {
    if (!iso) return '—';
    var d = new Date(String(iso));
    if (Number.isNaN(d.getTime())) return String(iso);
    return d.toLocaleString('zh-TW', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  }

  function isOfficialScanVendor(v) {
    var slug = String(v || '').trim();
    return OFFICIAL_SCAN_SLUGS.indexOf(slug) >= 0;
  }

  function preferOfficialScanSlug(slugs) {
    var list = Array.isArray(slugs) ? slugs.slice() : [];
    if (list.indexOf(OFFICIAL_SCAN_SLUG) >= 0) return OFFICIAL_SCAN_SLUG;
    if (list.indexOf(ADMIN_CODE) >= 0) return ADMIN_CODE;
    return '';
  }

  function ticketVendor(ticket) {
    if (!ticket) return '';
    return String(ticket.vendor || ticket.slug_handle || '').trim();
  }

  function isVoided(ticket) {
    var st = String(ticket && ticket.ticket_status || '').toUpperCase();
    return st === 'VOID' || st === 'VOIDED' || st === 'CANCELLED' || st === 'REFUNDED';
  }

  function getRedeemWindow(ticket) {
    var startRaw = ticket && (ticket.event_start_at || ticket.start_at);
    var endRaw = ticket && (ticket.event_end_at || ticket.end_at);
    var start = startRaw ? new Date(String(startRaw)).getTime() : null;
    var end = endRaw ? new Date(String(endRaw)).getTime() : null;
    var now = Date.now();
    return {
      start: start,
      end: end,
      tooEarly: start != null && now < (start - EARLY_REDEEM_MS),
      tooLate: end != null && now > end,
    };
  }

  var REASON_CODE_LABELS = {
    NOT_FOUND: '查無此票',
    FORBIDDEN_VENDOR: '非本廠商票券',
    ALREADY_REDEEMED: '已核銷',
    VOID_OR_REFUNDED: '已作廢或退款',
    PENDING_VENDOR_CONFIRM: '待廠商確認外部收款後才可核銷',
    NOT_ACTIVE: '票券尚未啟用',
    TOO_EARLY: '尚未開放報到',
    EVENT_ENDED: '活動已結束',
  };

  function reasonFromApi(apiReason, reasonCode) {
    var code = String(reasonCode || '').trim().toUpperCase();
    if (code && REASON_CODE_LABELS[code]) return REASON_CODE_LABELS[code];
    var text = String(apiReason || '').trim();
    return text || '';
  }

  function buildRejectReasons(ticket, win, staffVendor, apiReason, reasonCode) {
    var reasons = [];
    var admin = isOfficialScanVendor(staffVendor);
    var vendor = ticketVendor(ticket);
    if (!ticket || !ticket.ticket_uid) reasons.push('查無此票');
    if (ticket && ticket.redeemed) reasons.push('已核銷');
    if (isVoided(ticket)) reasons.push('已作廢或退款');
    if (ticket && vendor && vendor !== staffVendor && !admin) reasons.push('非本廠商票券');
    if (win.tooEarly) reasons.push('尚未開放報到');
    if (win.tooLate) reasons.push('活動已結束');
    // Mode B 等後端判定：前端本地規則未涵蓋時，採用 API reason
    var fromApi = reasonFromApi(apiReason, reasonCode);
    if (fromApi && reasons.indexOf(fromApi) < 0) reasons.push(fromApi);
    return { reasons: reasons, admin: admin };
  }

  function setHint(text) {
    if (!els.hint) return;
    if (!text) { els.hint.hidden = true; els.hint.textContent = ''; return; }
    els.hint.hidden = false;
    els.hint.textContent = text;
  }

  function setWarn(title, reasons) {
    if (!els.warn) return;
    if (!reasons || !reasons.length) { els.warn.innerHTML = ''; return; }
    var lis = reasons.map(function (r) { return '<li>' + escapeHtml(r) + '</li>'; }).join('');
    els.warn.innerHTML = '<div>' + escapeHtml(title || '不可核銷原因：') + '</div><ul>' + lis + '</ul>';
  }

  function setScanState(text) {
    if (els.state) els.state.textContent = text || '就緒';
  }

  function setBtnDisabled(btn, disabled) {
    if (!btn) return;
    btn.disabled = !!disabled;
  }

  function setRedeemDisabled(disabled) {
    els.btnRedeem.forEach(function (btn) { setBtnDisabled(btn, disabled); });
  }

  function setBusy(nextBusy, text) {
    busy = !!nextBusy;
    if (text) setScanState(text);
  }

  function statusHtml(ticket, reasonCode) {
    if (!ticket) return '—';
    if (isVoided(ticket)) return '<span class="lbscan-v2-pill lbscan-v2-pill--void">已作廢</span>';
    if (ticket.redeemed) return '<span class="lbscan-v2-pill">已核銷</span>';
    var code = String(reasonCode || '').trim().toUpperCase();
    var status = String(ticket.ticket_status || '').trim().toUpperCase();
    if (code === 'PENDING_VENDOR_CONFIRM' || status === 'PENDING_VENDOR_CONFIRM') {
      return '<span class="lbscan-v2-pill lbscan-v2-pill--void">待確認收款</span>';
    }
    return '<span class="lbscan-v2-pill lbscan-v2-pill--ok">未核銷</span>';
  }

  function applyEligibility(ticket, canRedeemFromApi, apiReason, reasonCode) {
    var staffVendor = String(selectedVendor || '').trim();
    var win = getRedeemWindow(ticket || {});
    var built = buildRejectReasons(ticket || {}, win, staffVendor, apiReason, reasonCode);
    var allowed = !!canRedeemFromApi && built.reasons.length === 0;

    els.fStatus.innerHTML = statusHtml(ticket, reasonCode);
    if (built.reasons.length || !allowed) {
      els.fPerm.textContent = '不可核銷 ⛔';
      els.fPerm.className = 'lbscan-v2-v lbscan-v2-v--sm lbscan-v2-v--bad';
      setRedeemDisabled(true);
      setWarn(
        '不可核銷原因：',
        built.reasons.length
          ? built.reasons
          : [reasonFromApi(apiReason, reasonCode) || '系統判定不可核銷']
      );
    } else {
      els.fPerm.textContent = built.admin ? '可核銷 ✅（全廠商）' : '可核銷 ✅';
      els.fPerm.className = 'lbscan-v2-v lbscan-v2-v--sm lbscan-v2-v--ok';
      setRedeemDisabled(false);
      setWarn('', []);
    }
    lastCanRedeem = allowed;
    lastApiReason = String(apiReason || '').trim();
    lastReasonCode = String(reasonCode || '').trim();
    return { allowed: allowed, admin: built.admin, reasons: built.reasons };
  }

  function renderTicket(ticket, canRedeemFromApi, apiReason, reasonCode) {
    lastTicket = ticket || null;
    var vendor = ticketVendor(ticket);
    els.fName.textContent = ticket && ticket.name ? ticket.name : '—';
    els.fPhone.textContent = ticket && ticket.phone ? ticket.phone : '—';
    els.fId4.textContent = ticket && ticket.id4 ? ticket.id4 : '—';
    els.fEvent.textContent = ticket && ticket.event_title ? ticket.event_title : '—';
    var sIso = ticket && (ticket.event_start_at || ticket.start_at);
    var eIso = ticket && (ticket.event_end_at || ticket.end_at);
    if (sIso && eIso) els.fTime.textContent = fmtLocal(sIso) + ' ～ ' + fmtLocal(eIso);
    else if (sIso) els.fTime.textContent = fmtLocal(sIso);
    else if (eIso) els.fTime.textContent = '～ ' + fmtLocal(eIso);
    else els.fTime.textContent = '—';
    els.fType.textContent = ticket && ticket.ticket_type ? ticket.ticket_type : '—';
    els.fVendor.textContent = vendor || '—';
    return applyEligibility(ticket, canRedeemFromApi, apiReason, reasonCode);
  }

  function resetRight() {
    lastTicket = null;
    lastCanRedeem = false;
    lastApiReason = '';
    lastReasonCode = '';
    els.fStatus.textContent = '—';
    els.fPerm.textContent = '—';
    els.fName.textContent = '—';
    els.fPhone.textContent = '—';
    els.fId4.textContent = '—';
    els.fEvent.textContent = '—';
    els.fTime.textContent = '—';
    els.fType.textContent = '—';
    els.fVendor.textContent = '—';
    setRedeemDisabled(true);
    setWarn('', []);
  }

  function getVendorRequired() {
    var v = String(selectedVendor || '').trim();
    if (!v) {
      setHint('尚未選擇授權廠商。');
      return '';
    }
    return v;
  }

  function vendorForRedeemApi(staffVendor, ticket) {
    if (isOfficialScanVendor(staffVendor)) {
      return ticketVendor(ticket) || staffVendor;
    }
    return staffVendor;
  }

  async function fetchAuthorizedVendors() {
    var payload = null;
    var cache = window.LbVendorAuthCache;
    if (cache && typeof cache.fetchAuthorized === 'function') {
      var cached = await cache.fetchAuthorized(PATHS.authorized);
      payload = cached.payload;
      if (!cached.ok || !payload || payload.ok !== true) return { ok: false, slugs: [], roles: {} };
    } else {
      var response = await fetch(PATHS.authorized, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      try { payload = await response.json(); } catch (e) { payload = null; }
      if (!response.ok || !payload || payload.ok !== true) return { ok: false, slugs: [], roles: {} };
    }
    var items = Array.isArray(payload.items) ? payload.items : [];
    var slugs = [];
    var roles = {};
    items.forEach(function (item) {
      var slug = String(item && item.slug_handle || '').trim();
      var role = String(item && item.role || '').trim().toLowerCase();
      if (!slug) return;
      if (slugs.indexOf(slug) < 0) slugs.push(slug);
      roles[slug] = role;
    });
    return { ok: true, slugs: slugs, roles: roles };
  }

  var SCAN_API_TIMEOUT_MS = 15000;

  async function fetchScanApi(path, vendorSlug, body) {
    var params = new URLSearchParams();
    params.set('vendor_slug', vendorSlug);
    // 現場行動網路不穩時，沒有 timeout 的請求會讓整台核銷機卡住不動。
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, SCAN_API_TIMEOUT_MS) : null;
    var response;
    try {
      response = await fetch(path + '?' + params.toString(), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body || {}),
        signal: controller ? controller.signal : undefined,
      });
    } finally {
      if (timer) clearTimeout(timer);
    }
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    if (!response.ok || !payload) {
      var code = payload && payload.error && payload.error.code ? payload.error.code : '查詢失敗（HTTP ' + response.status + '）';
      var message = payload && payload.error && payload.error.message ? payload.error.message : '';
      return { ok: false, code: code, message: message, payload: payload };
    }
    return { ok: true, payload: payload };
  }

  var ROLE_LABELS = { owner: '擁有者', admin: '管理員', staff: '工作人員', scan_only: '僅掃碼' };
  var vendorPickerBound = false;
  var vendorPickerOpen = false;

  function vendorRoleLabel(slug) {
    var raw = vendorRoleBySlug[slug] || '';
    return ROLE_LABELS[raw] || raw || '';
  }

  function ensureVendorPickerMenuOnBody() {
    var menu = els.vendorMenu;
    if (menu && menu.parentNode !== document.body) document.body.appendChild(menu);
    return menu;
  }

  function closeVendorPicker() {
    var btn = els.vendorBtn;
    var menu = ensureVendorPickerMenuOnBody();
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (menu) {
      menu.hidden = true;
      menu.removeAttribute('style');
    }
    vendorPickerOpen = false;
  }

  function positionVendorPickerMenu() {
    var btn = els.vendorBtn;
    var menu = ensureVendorPickerMenuOnBody();
    if (!btn || !menu || menu.hidden) return;
    var rect = btn.getBoundingClientRect();
    var width = Math.max(rect.width, Math.min(420, window.innerWidth - 24));
    var left = Math.min(rect.left, window.innerWidth - width - 12);
    left = Math.max(12, left);
    var top = rect.bottom + 8;
    var maxH = Math.min(420, window.innerHeight * 0.6);
    if (top + Math.min(maxH, 240) > window.innerHeight - 12) {
      top = Math.max(12, rect.top - 8 - Math.min(maxH, rect.top - 12));
    }
    menu.style.position = 'fixed';
    menu.style.top = Math.round(top) + 'px';
    menu.style.left = Math.round(left) + 'px';
    menu.style.width = Math.round(width) + 'px';
    menu.style.maxHeight = Math.round(maxH) + 'px';
    menu.style.zIndex = '2147483000';
  }

  function openVendorPicker() {
    if (activeVendors.length <= 1) return;
    var btn = els.vendorBtn;
    var menu = ensureVendorPickerMenuOnBody();
    if (!btn || !menu) return;
    renderVendorMenuOptions();
    menu.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    vendorPickerOpen = true;
    positionVendorPickerMenu();
    if (els.vendorFilter && els.vendorSearchWrap && !els.vendorSearchWrap.hidden) {
      try { els.vendorFilter.focus(); } catch (e) { /* ignore */ }
    }
  }

  function updateVendorTrigger() {
    var role = vendorRoleLabel(selectedVendor);
    if (els.vendor) els.vendor.value = selectedVendor;
    if (els.vendorValue) els.vendorValue.textContent = selectedVendor || '選擇廠商';
    if (els.vendorRole) {
      els.vendorRole.textContent = role;
      els.vendorRole.hidden = !role;
    }
    if (els.vendorBtn) {
      var multi = activeVendors.length > 1;
      els.vendorBtn.classList.toggle('is-static', !multi);
      els.vendorBtn.setAttribute('aria-disabled', multi ? 'false' : 'true');
      els.vendorBtn.tabIndex = multi ? 0 : -1;
      els.vendorBtn.title = selectedVendor
        ? (role ? selectedVendor + ' · ' + role : selectedVendor)
        : '選擇廠商';
    }
  }

  function renderVendorMenuOptions() {
    var list = els.vendorList;
    if (!list) return;
    var q = els.vendorFilter ? String(els.vendorFilter.value || '').trim().toLowerCase() : '';
    var html = '';
    var shown = 0;
    activeVendors.forEach(function (slug) {
      var role = vendorRoleLabel(slug);
      if (q && slug.toLowerCase().indexOf(q) < 0 && role.toLowerCase().indexOf(q) < 0) return;
      shown += 1;
      var selected = slug === selectedVendor;
      html +=
        '<li role="presentation">' +
          '<div role="option" class="lbscan-v2-vendor-picker__option' + (selected ? ' is-active' : '') +
          '" data-vendor="' + escapeHtml(slug) + '"' +
          ' aria-selected="' + (selected ? 'true' : 'false') + '"' +
          ' tabindex="-1">' +
            '<span class="lbscan-v2-vendor-picker__option-name">' + escapeHtml(slug) + '</span>' +
            (role ? '<span class="lbscan-v2-vendor-picker__option-role">' + escapeHtml(role) + '</span>' : '') +
          '</div>' +
        '</li>';
    });
    if (!shown) {
      html = '<li class="lbscan-v2-vendor-picker__empty" role="presentation">沒有符合的廠商</li>';
    }
    list.innerHTML = html;
  }

  function selectVendor(slug) {
    if (!slug || activeVendors.indexOf(slug) < 0) return;
    if (slug === selectedVendor) {
      closeVendorPicker();
      return;
    }
    selectedVendor = slug;
    updateVendorTrigger();
    renderVendorMenuOptions();
    closeVendorPicker();
    resetRight();
    lastCode = '';
    if (els.code) els.code.value = '';
  }

  function bindVendorPicker() {
    if (vendorPickerBound) return;
    var btn = els.vendorBtn;
    var menu = els.vendorMenu;
    if (!btn || !menu) return;
    vendorPickerBound = true;

    function toggleVendorPicker(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (activeVendors.length <= 1) return;
      if (vendorPickerOpen) closeVendorPicker();
      else openVendorPicker();
    }

    btn.addEventListener('click', toggleVendorPicker);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') toggleVendorPicker(e);
    });

    menu.addEventListener('click', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('[data-vendor]') : null;
      if (!item) return;
      e.preventDefault();
      selectVendor(item.getAttribute('data-vendor') || '');
    });

    if (els.vendorFilter) {
      els.vendorFilter.addEventListener('input', function () {
        renderVendorMenuOptions();
      });
      els.vendorFilter.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeVendorPicker();
      });
    }

    document.addEventListener('click', function (e) {
      if (!vendorPickerOpen) return;
      var picker = $('lb-scan-v2-vendor-picker');
      var menuEl = els.vendorMenu;
      if (picker && e.target && picker.contains(e.target)) return;
      if (menuEl && e.target && menuEl.contains(e.target)) return;
      closeVendorPicker();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vendorPickerOpen) closeVendorPicker();
    });

    window.addEventListener('resize', function () {
      if (vendorPickerOpen) positionVendorPickerMenu();
    });
    window.addEventListener('scroll', function (e) {
      if (!vendorPickerOpen) return;
      var menuEl = els.vendorMenu;
      var t = e && e.target;
      if (menuEl && (t === menuEl || (t && menuEl.contains && menuEl.contains(t)))) return;
      if (els.vendorList && (t === els.vendorList || (t && els.vendorList.contains && els.vendorList.contains(t)))) return;
      positionVendorPickerMenu();
    }, true);
  }

  function renderVendorPicker() {
    bindVendorPicker();
    if (els.vendorSearchWrap) els.vendorSearchWrap.hidden = activeVendors.length <= 6;
    if (els.vendorFilter) els.vendorFilter.value = '';
    updateVendorTrigger();
    renderVendorMenuOptions();
    closeVendorPicker();
  }

  function openModal(title, sub, ticket, reasons) {
    if (!els.modal) return;
    modalOpen = true;
    els.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lbscan-v2-modal-open');
    els.mTitle.textContent = title || '顧客資訊';
    els.mSub.textContent = sub || '—';
    els.mStatus.innerHTML = statusHtml(ticket);
    els.mName.textContent = ticket && ticket.name ? ticket.name : '—';
    els.mPhone.textContent = ticket && ticket.phone ? ticket.phone : '—';
    els.mId4.textContent = ticket && ticket.id4 ? ticket.id4 : '—';
    els.mEvent.textContent = ticket && ticket.event_title ? ticket.event_title : '—';
    if (reasons && reasons.length) {
      els.mWarn.innerHTML = '<ul>' + reasons.map(function (r) {
        return '<li>' + escapeHtml(r) + '</li>';
      }).join('') + '</ul>';
    } else {
      els.mWarn.innerHTML = '';
    }
    if (els.mRedeem) {
      els.mRedeem.hidden = !(ticket && lastCanRedeem && !ticket.redeemed);
    }
  }

  function closeModal(goNext) {
    if (!els.modal) return;
    modalOpen = false;
    els.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lbscan-v2-modal-open');
    if (goNext) nextTicket();
  }

  async function lookup(codeRaw, opts) {
    var staffVendor = getVendorRequired();
    if (!staffVendor) return;
    if (busy) {
      setHint('查詢處理中，請稍候…');
      return;
    }

    var code = normCode(codeRaw);
    if (!code) { setHint('請貼上驗證碼或掃碼。'); return; }

    setHint('');
    setBusy(true, '查詢中…');
    lastCode = code;
    if (els.code) els.code.value = code;
    if (cameraRunning) acceptScan = false;

    try {
      var result = await fetchScanApi(PATHS.lookup, staffVendor, {
        code: code,
        staff: (els.staff && els.staff.value || '').trim(),
      });

      if (!result.ok) {
        resetRight();
        setScanState('查詢失敗');
        if (isMobileNow()) {
          openModal('查詢失敗', result.message || result.code, null, ['網路或系統回應異常']);
        }
        if (cameraRunning && !modalOpen) { acceptScan = true; setScanState('掃碼中…'); }
        return;
      }

      var payload = result.payload;
      var ticket = payload.ticket || {};
      var elig = renderTicket(
        ticket,
        payload.can_redeem === true,
        payload.reason || '',
        payload.reason_code || ''
      );
      setScanState('已讀取');

      // 核銷過程中連線異常後的重新查詢：以伺服器狀態為準給出明確結論，
      // 不讓現場人員只憑「核銷失敗」四個字猜測。
      if (opts && opts.reconcile) {
        var confirmedRedeemed = !!(ticket && ticket.redeemed);
        if (confirmedRedeemed) {
          setWarn('完成：', ['核銷成功 ✅（連線異常後已確認）']);
          setScanState('核銷成功');
        } else {
          setWarn('尚未核銷：', ['伺服器未收到核銷，請再按一次核銷']);
          setScanState('尚未核銷');
        }
        if (isMobileNow()) {
          openModal(
            confirmedRedeemed ? '核銷成功' : '尚未核銷',
            confirmedRedeemed ? '連線異常後已確認核銷完成' : '請再按一次核銷',
            ticket,
            confirmedRedeemed ? [] : ['伺服器未收到這筆核銷']
          );
        }
        if (cameraRunning && !modalOpen) { acceptScan = true; setScanState('掃碼中…'); }
        return;
      }

      var fromScan = !!(opts && opts.fromScan);
      var autoChecked = !!(els.optAutoRedeem && els.optAutoRedeem.checked);

      if (isMobileNow()) {
        openModal(
          elig.allowed ? '顧客資訊' : '不可核銷',
          fromScan ? '掃碼結果' : '查詢結果',
          ticket,
          elig.allowed ? [] : elig.reasons
        );
      }

      if (fromScan && autoChecked && elig.allowed && ticket && !ticket.redeemed) {
        setBusy(false);
        await redeem({ auto: true });
        return;
      }

      if (cameraRunning && !modalOpen) { acceptScan = true; setScanState('掃碼中…'); }
    } catch (err) {
      resetRight();
      setScanState('查詢失敗');
      setWarn('查詢失敗：', [err && err.message ? '操作失敗（' + String(err.message) + '）' : '網路異常']);
      if (cameraRunning && !modalOpen) { acceptScan = true; setScanState('掃碼中…'); }
    } finally {
      setBusy(false);
    }
  }

  function confirmRedeem(ticket) {
    if (typeof window.confirm !== 'function') return true;
    var who = ticket && (ticket.name || ticket.buyer_name) ? String(ticket.name || ticket.buyer_name) : '';
    var what = ticket && ticket.event_title ? String(ticket.event_title) : '';
    var lines = ['確定要核銷這張票嗎？核銷後無法復原。'];
    if (what) lines.push('課程：' + what);
    if (who) lines.push('姓名：' + who);
    return window.confirm(lines.join('\n'));
  }

  async function redeem(opts) {
    var staffVendor = getVendorRequired();
    if (!staffVendor) return;
    if (busy) {
      setHint('核銷處理中，請稍候…');
      return;
    }
    if (!lastCode) {
      setWarn('不可核銷原因：', ['請先掃碼或查詢']);
      return;
    }

    var elig = applyEligibility(lastTicket || {}, lastCanRedeem, lastApiReason, lastReasonCode);
    if (!elig.allowed) {
      setWarn(
        '不可核銷原因：',
        elig.reasons.length
          ? elig.reasons
          : [reasonFromApi(lastApiReason, lastReasonCode) || '不符合核銷資格']
      );
      if (isMobileNow() && !modalOpen) {
        openModal('不可核銷', '不符合核銷資格', lastTicket, elig.reasons);
      }
      return;
    }

    // 核銷不可逆。自動核銷是掃碼流程的一部分不另外確認，手動按鈕則要求確認，
    // 避免在忙碌的入場現場誤觸而把別人的票核掉。
    if (!(opts && opts.auto) && !confirmRedeem(lastTicket)) {
      setHint('已取消核銷。');
      return;
    }

    setBusy(true, '核銷中…');
    setRedeemDisabled(true);

    try {
      var result = await fetchScanApi(PATHS.redeem, staffVendor, {
        code: lastCode,
        staff: (els.staff && els.staff.value || '').trim(),
      });

      if (!result.ok || result.payload.ok === false) {
        setRedeemDisabled(false);
        var payload = result.payload || {};
        var rawReason = payload.reason || payload.message || result.message || '';
        var reason = rawReason ? '核銷失敗（' + rawReason + '）' : '核銷失敗';
        setWarn('核銷失敗：', [reason]);
        setScanState('核銷失敗');
        if (isMobileNow()) openModal('核銷失敗', reason, lastTicket, [reason]);
        return;
      }

      var payload = result.payload;
      var ticket = payload.ticket || lastTicket || {};
      ticket.redeemed = true;
      if (payload.ticket && payload.ticket.redeemed_at) ticket.redeemed_at = payload.ticket.redeemed_at;
      lastTicket = ticket;
      renderTicket(ticket, false, '', '');
      setWarn('完成：', ['核銷成功 ✅']);
      setScanState('核銷成功');

      if (isMobileNow()) {
        openModal(
          '核銷成功',
          opts && opts.auto ? '自動核銷 ✅' : '手動核銷 ✅',
          ticket,
          []
        );
        if (els.mRedeem) els.mRedeem.hidden = true;
      }

      if (cameraRunning && !modalOpen) { acceptScan = true; setScanState('掃碼中…'); }
    } catch (err) {
      setRedeemDisabled(false);
      // 網路中斷或逾時的當下無法判斷伺服器到底有沒有核銷成功。直接顯示「核銷失敗」
      // 會讓現場人員重按或請顧客重新排隊，但票其實可能已經核掉了。
      // 這裡改成標示狀態未確定，並在下方重新查詢一次以伺服器狀態為準。
      var aborted = err && err.name === 'AbortError';
      var msg = aborted
        ? '連線逾時，正在確認核銷是否已完成…'
        : (err && err.message ? '連線異常（' + String(err.message) + '），正在確認核銷結果…' : '網路異常，正在確認核銷結果…');
      setWarn('核銷結果未確定：', [msg]);
      setScanState('確認中…');
      if (isMobileNow()) openModal('核銷結果未確定', msg, lastTicket, [msg]);
      setBusy(false);
      await lookup(lastCode, { reconcile: true });
      return;
    } finally {
      setBusy(false);
    }
  }

  function nextTicket() {
    lastCode = '';
    lastTicket = null;
    lastCanRedeem = false;
    if (els.code) els.code.value = '';
    resetRight();
    setScanState(cameraRunning ? '掃碼中…' : '就緒');
    setHint('');
    if (cameraRunning) acceptScan = true;
  }

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function () { resolve(true); };
      s.onerror = function () { reject(new Error('load_failed')); };
      document.head.appendChild(s);
    });
  }

  function scanConfig() {
    return {
      fps: 10,
      aspectRatio: 1.0,
    };
  }

  async function ensureHtml5Qr() {
    if (window.Html5Qrcode) return true;
    var urls = [];
    if (config.qrLibUrl) urls.push(config.qrLibUrl);
    urls.push(
      'https://unpkg.com/html5-qrcode@2.3.8/html5-qrcode.min.js',
      'https://cdn.jsdelivr.net/npm/html5-qrcode@2.3.8/html5-qrcode.min.js'
    );
    for (var i = 0; i < urls.length; i++) {
      try {
        await loadScript(urls[i]);
        if (window.Html5Qrcode) return true;
      } catch (e) {}
    }
    return false;
  }

  async function startScan() {
    var staffVendor = getVendorRequired();
    if (!staffVendor) return;
    if (!window.isSecureContext) {
      setScanState('相機不可用');
      setHint('需要 HTTPS 才能開啟相機。');
      return;
    }
    scanning = true;
    cameraRunning = true;
    acceptScan = true;
    setScanState(window.Html5Qrcode ? '初始化相機…' : '載入掃描元件…');
    els.btnStart.forEach(function (b) {
      if (b) {
        b.dataset.lbPrevLabel = b.textContent || '';
        if (!window.Html5Qrcode) b.textContent = '載入掃描元件…';
        setBtnDisabled(b, true);
      }
    });
    els.btnStop.forEach(function (b) { setBtnDisabled(b, false); });

    var ok = await ensureHtml5Qr();
    els.btnStart.forEach(function (b) {
      if (b && b.dataset.lbPrevLabel) b.textContent = b.dataset.lbPrevLabel;
    });
    if (!ok) {
      scanning = false;
      cameraRunning = false;
      setScanState('掃碼庫載入失敗');
      els.btnStart.forEach(function (b) { setBtnDisabled(b, false); });
      els.btnStop.forEach(function (b) { setBtnDisabled(b, true); });
      return;
    }
    setScanState('初始化相機…');

    try {
      if (!html5qr) html5qr = new Html5Qrcode('lb-scan-v2-qr-host');
      if (els.camPlaceholder) els.camPlaceholder.style.display = 'none';
      if (els.reader) els.reader.classList.add('lbscan-v2-reader--active');
      await html5qr.start(
        { facingMode: 'environment' },
        scanConfig(),
        function (decodedText) {
          if (!scanning || !acceptScan || busy || modalOpen) return;
          acceptScan = false;
          lookup(decodedText, { fromScan: true });
        },
        function () {}
      );
      setScanState('掃碼中…');
    } catch (e) {
      scanning = false;
      cameraRunning = false;
      setScanState('相機啟動失敗');
      els.btnStart.forEach(function (b) { setBtnDisabled(b, false); });
      els.btnStop.forEach(function (b) { setBtnDisabled(b, true); });
      if (els.camPlaceholder) els.camPlaceholder.style.display = '';
      if (els.reader) els.reader.classList.remove('lbscan-v2-reader--active');
    }
  }

  async function stopScan() {
    scanning = false;
    cameraRunning = false;
    acceptScan = false;
    els.btnStop.forEach(function (b) { setBtnDisabled(b, true); });
    if (html5qr) {
      try { await html5qr.stop(); } catch (e) {}
    }
    if (els.camPlaceholder) els.camPlaceholder.style.display = '';
    if (els.reader) els.reader.classList.remove('lbscan-v2-reader--active');
    setScanState('已停止');
  }

  function bindButtons(list, handler) {
    list.forEach(function (btn) {
      if (btn) btn.addEventListener('click', handler);
    });
  }

  function initAutoRedeemPrefs() {
    try {
      var k = 'lb_scan_v2_auto_redeem';
      if (els.optAutoRedeem) {
        els.optAutoRedeem.checked = localStorage.getItem(k) === '1';
        els.optAutoRedeem.addEventListener('change', function () {
          localStorage.setItem(k, els.optAutoRedeem.checked ? '1' : '0');
        });
      }
    } catch (e) {}
  }

  async function bootstrap() {
    if (!config.loggedIn) {
      els.login.hidden = false;
      var loginLink = $('lb-scan-v2-login-link');
      if (loginLink && config.returnPath) {
        loginLink.href = config.loginUrl + '?return_url=' + encodeURIComponent(config.returnPath);
      }
      return;
    }

    var bootTimer = setTimeout(function () {
      if (els.bootstrap) els.bootstrap.hidden = false;
    }, 400);
    var bootText = $('lb-scan-v2-bootstrap-text');
    if (bootText) bootText.textContent = '授權確認中…';
    var auth = await fetchAuthorizedVendors();
    clearTimeout(bootTimer);
    if (els.bootstrap) els.bootstrap.hidden = true;

    if (!auth.ok || !auth.slugs.length) {
      els.noAuth.hidden = false;
      return;
    }

    var scanRoles = { owner: 1, staff: 1, scan_only: 1, admin: 1 };
    vendorRoleBySlug = auth.roles;
    activeVendors = auth.slugs.filter(function (slug) {
      return !!scanRoles[vendorRoleBySlug[slug]];
    });

    if (!activeVendors.length) {
      els.noAuth.hidden = false;
      return;
    }

    var officialSlug = preferOfficialScanSlug(activeVendors);
    if (officialSlug) {
      activeVendors = [officialSlug];
    }

    selectedVendor = activeVendors[0];
    if (els.vendor) els.vendor.value = selectedVendor;
    renderVendorPicker();

    els.app.hidden = false;
    if (isMobileNow() && els.fixed) els.fixed.hidden = false;

    initAutoRedeemPrefs();
    resetRight();
    setScanState('就緒');

    bindButtons(els.btnStart, startScan);
    bindButtons(els.btnStop, stopScan);
    bindButtons(els.btnRedeem, function () { redeem({ auto: false }); });
    bindButtons(els.btnNext, nextTicket);
    if (els.btnLookup) els.btnLookup.addEventListener('click', function () {
      lookup(els.code && els.code.value, { fromScan: false });
    });
    if (els.code) {
      els.code.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') lookup(els.code.value, { fromScan: false });
      });
    }
    if (els.mDone) els.mDone.addEventListener('click', function () { closeModal(true); });
    if (els.mClose) els.mClose.addEventListener('click', function () { closeModal(true); });
    if (els.mBackdrop) els.mBackdrop.addEventListener('click', function () { closeModal(true); });
    if (els.mRedeem) els.mRedeem.addEventListener('click', function () { redeem({ auto: false }); });
  }

  bootstrap();
})();
